import React from 'react';
import LogoCarousel from './LogoCarousel';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="mt-4 p-4">
      {/* Logo Carousel Section */}
      <LogoCarousel />
      
      {/* Social Links Section */}
      <div className="social-links-section">
        <div className="container">
          <h5 className="text-center mb-3">Follow Us</h5>
          <div className="social-links">
            <a href="https://www.facebook.com/kidsblackhistory" target="_blank" rel="noreferrer" className="social-link">
              <i className="fab fa-facebook"></i>
              <span>Facebook</span>
            </a>
            <a href="https://www.youtube.com/@KidsBlackHistory" target="_blank" rel="noreferrer" className="social-link">
              <i className="fab fa-youtube"></i>
              <span>YouTube</span>
            </a>
            <a href="https://www.twitter.com/kidsblkhistory" target="_blank" rel="noreferrer" className="social-link">
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a href="https://www.linkedin.com/company/kids-black-history" target="_blank" rel="noreferrer" className="social-link">
              <i className="fab fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>
            <a href="https://www.instagram.com/kidsblackhistory" target="_blank" rel="noreferrer" className="social-link">
              <i className="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 